import api from '../../api'

const recurrenceAPI = api.create('recurrence')

const getConfigGateway = async () => {
  return await recurrenceAPI.get('/tax_invoice/sellers/get_config_gateway')
}

const setup = async data => {
  return await recurrenceAPI.post('/tax_invoice/sellers/setup', data)
}

export default { getConfigGateway, setup }
